// extracted by mini-css-extract-plugin
export var calendarView = "_67-0";